import {
	SET_GUIDES,
	SET_GUIDE,
	CLEAR_GUIDES,
	CLEAR_GUIDE,
	ADD_GUIDE,
	UPDATE_GUIDE,
	REMOVE_GUIDE,
} from './actionTypes';

export const guide = (state = {}, action) => {
	switch (action.type) {
		case SET_GUIDE:
			return action.payload;
		case UPDATE_GUIDE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_GUIDE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_GUIDES:
			return action.payload;
		case ADD_GUIDE:
			return [...state, action.payload];
		case UPDATE_GUIDE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_GUIDE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_GUIDES:
			return [];
		default:
			return state;
	}
};
